function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-30 w-full">
      <div className="max-w-6xl mx-auto px-3 md:px-6 py-2 md:py-3 mt-2 md:mt-3 rounded-2xl glass-nav flex items-center justify-between gap-3 md:gap-6">
        <a href="/#about" className="shrink-0 whitespace-nowrap text-base sm:text-lg md:text-xl text-slate-900 font-extrabold tracking-tight">
          Marko Piljak
        </a>

        <nav className="flex items-center gap-2 sm:gap-4 md:gap-8 text-sm md:text-base font-semibold text-slate-700 whitespace-nowrap">
          <a href="/#about" className="hover:text-cyan-700 transition-colors">Über mich</a>
          <a href="/#projects" className="hover:text-cyan-700 transition-colors">Projekte</a>
          <a href="/#contact" className="hover:text-cyan-700 transition-colors">Kontakt</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;